import { InstagramLogo } from "@phosphor-icons/react";
import { integrationProviderRegistry } from "../integration_registry.js";
import {
  InstagramConfigEditor,
  makeZernioChannelComponent,
} from "../zernio.js";

function InstagramIcon() {
  return <InstagramLogo size={20} />;
}

integrationProviderRegistry.register(
  makeZernioChannelComponent({
    platform: "instagram",
    label: "Instagram",
    Icon: InstagramIcon,
    ConfigEditor: InstagramConfigEditor,
  }),
);
